
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 -10 169 37","fill-opacity":"0","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.334 8.504v.002c-.272.47-.745.767-1.252.846l-8.68 1.341L7.5 16.38c.394.368.6.91.51 1.469l-1.29 7.98 8.036-3.645a1.81 1.81 0 011.49 0l8.036 3.644-1.29-7.98a1.646 1.646 0 01.51-1.468l6.096-5.687-8.678-1.341h-.001a1.747 1.747 0 01-1.251-.846l-.001-.002L15.5 1.223l-4.166 7.281zm13.365 17.514zM46.003 8.492v.001c-.261.47-.725.776-1.236.858h-.001l-8.389 1.34 5.914 5.7c.385.372.577.908.492 1.453l-1.245 7.961 7.716-3.615a1.76 1.76 0 011.492 0l7.716 3.615-1.245-7.962a1.658 1.658 0 01.492-1.451l5.914-5.701-8.39-1.34a1.723 1.723 0 01-1.235-.858l-.001-.001L50 1.273l-3.997 7.219zm12.924 17.531zM80.334 8.504v.002c-.272.47-.745.767-1.252.846l-8.68 1.341L76.5 16.38c.394.368.6.91.51 1.469l-1.29 7.98 8.036-3.645a1.81 1.81 0 011.49 0l8.036 3.644-1.29-7.98a1.646 1.646 0 01.51-1.468l6.096-5.687-8.678-1.341h-.001a1.747 1.747 0 01-1.251-.846l-.001-.002L84.5 1.223l-4.166 7.281zm13.365 17.514zM115.003 8.492l-.001.001a1.72 1.72 0 01-1.235.858h-.001l-8.389 1.34 5.914 5.7c.385.372.577.908.492 1.453l-1.245 7.961 7.716-3.615h.001a1.76 1.76 0 011.491 0l7.716 3.615-1.245-7.962h-.001a1.659 1.659 0 01.493-1.451h.001l5.913-5.701-8.389-1.34h-.001a1.721 1.721 0 01-1.235-.858l-.001-.001L119 1.273l-3.997 7.219zm12.924 17.531zM149.334 8.504l-.001.002a1.747 1.747 0 01-1.251.846h-.001l-8.679 1.341 6.097 5.687c.394.368.6.91.51 1.469l-1.29 7.98 8.036-3.645a1.81 1.81 0 011.49 0l8.036 3.644-1.29-7.98a1.644 1.644 0 01.51-1.468h.001l6.096-5.687-8.68-1.341a1.747 1.747 0 01-1.251-.846l-.001-.002-4.166-7.281-4.166 7.281z","fill":"none"}})])
          )
        }
      }
    